export class SearchCriteria {

  static readonly changeMadeOn: number = 1;
  static readonly changeMadeBefore: number = 2;
  static readonly changeMadeAfter: number = 3;
  static readonly changeMadeBetween: number = 4;
  static readonly changeMadeAll: number = 5;

  fromDate: Date = new Date();
  toDate: Date = new Date();
  area: string = '';
  field: string = '';
  action: string = '';
  count: number = 50;
  offset: number = 0;
  changeMadeOperator: number = SearchCriteria.changeMadeAll;
  constituentId: string = '';
  listId: string | null = null;
  listName: string = '';
  sortField: string = 'DateChange';
  sortDesc: boolean = true;
  orgId: string = '';
  envId: string = '';
  changedByList: string[] = [];
}
